import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../App";
import { fetchDataFromApi } from "../../utils/api";
import HomeBanner from "../../Components/HomeBanner";
import HomeCat from "../../Components/HomeCat";
import PopularProducts from "./PopularProducts";
import NewProducts from "./NewProducts";
import FeaturedProducts from "./FeaturedProducts";
import RandomCategoryProducts from "./RandomCategoryProducts";
import SideBanners from "./SideBanners";
import BottomBanners from "./BottomBanners";
import homeBannerPlaceholder from "../../assets/images/homeBannerPlaceholder.jpg";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const [homeSlides, setHomeSlides] = useState([]);
  const [bannerList, setBannerList] = useState([]);
  const [homeSideBanners, setHomeSideBanners] = useState([]);
  const [homeBottomBanners, setHomeBottomBanners] = useState([]);
  const [homeSideBannersLoading, setHomeSideBannersLoading] = useState(true);
  const context = useContext(MyContext);

  const safeFilter = (data, callback) => {
    try {
      if (Array.isArray(data)) {
        return data?.filter(callback);
      }
      return [];
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    context.setIsHeaderFooterShow(true);
    context.setEnableFilterTab(false);
    context.setIsBottomShow(true);

    fetchDataFromApi("/api/homeBanner")
      .then((res) => {
        setHomeSlides(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        console.error("Error fetching home banner:", error);
        setHomeSlides([]);
      });

    fetchDataFromApi("/api/banners")
      .then((res) => {
        setBannerList(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        console.error("Error fetching banners:", error);
        setBannerList([]);
      });

    fetchDataFromApi("/api/homeSideBanners")
      .then((res) => {
        setHomeSideBannersLoading(false);
        setHomeSideBanners(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        console.error("Error fetching homeSideBanners:", error);
        setHomeSideBanners([]);
      });

    fetchDataFromApi("/api/homeBottomBanners")
      .then((res) => {
        setHomeBottomBanners(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        console.error("Error fetching home bottom banners:", error);
        setHomeBottomBanners([]);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Sabbafarm - India's No.1 Agri Shop for Seeds, Fertilizers & Farm Tools
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Sabbafarm (often searched as Sabba Farm) is India's leading agri shop since 2006. Buy seeds, fertilizers, pesticides, and farming tools online with free delivery across India."
        />

        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="Sabbafarm, Sabba Farm, sabafarm, buy seeds online India, agriculture products, online agri shop, fertilizers, pesticides, irrigation tools, farm tools, organic farming products"
        />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://sabbafarm.com/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Sabbafarm - India's Trusted Online Agri Shop"
        />
        <meta
          property="og:description"
          content="Shop online at Sabbafarm (also known as Sabba Farm) for high-quality seeds, fertilizers, and farm tools. Trusted by Indian farmers since 2006."
        />
        <meta property="og:url" content="https://sabbafarm.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://sabbafarm.com/images/og-image.jpg"
        />
      </Helmet>

      {homeSlides?.length !== 0 ? (
        <div>
          <HomeBanner data={homeSlides} />
        </div>
      ) : (
        <div className="container mt-3">
          <div className="homeBannerSection">
            <img
              src={homeBannerPlaceholder}
              className="w-100"
              alt="Home Banner Placeholder"
            />
          </div>
        </div>
      )}

      {safeFilter(context.categoryData, (cat) => !!cat).length !== 0 && (
        <HomeCat catData={context.categoryData} />
      )}

      <section className="homeProducts pb-0">
        <div className="container">
          <div className="row homeProductsRow">
            <div className="col-md-3">
              <SideBanners
                homeSideBanners={homeSideBanners}
                isLoading={homeSideBannersLoading}
              />
            </div>

            <div className="col-md-9 productRow">
              <PopularProducts />
              <NewProducts />
              {bannerList?.length !== 0 && (
                <BottomBanners data={bannerList} col={3} />
              )}
            </div>
          </div>

          <div className="mt-4">
            <img src="/tags-small.webp" alt="" className="w-full sm:hidden" />
            <img src="/tags.webp" alt="" className="w-full hidden sm:block" />
          </div>

          <FeaturedProducts />

          <div className="mb-4">
            {homeSlides?.length !== 0 ? (
              <HomeBanner data={homeBottomBanners} />
            ) : (
              <div className="container mt-3">
                <div className="homeBannerSection">
                  <img
                    src={homeBannerPlaceholder}
                    className="w-100"
                    alt="Home Banner Placeholder"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <div className="container">
        <RandomCategoryProducts />
      </div>
    </>
  );
};

export default Home;
